export default __webpack_public_path__ + "static/media/egg-whisk.7c0b1088.mp3";